import React from 'react'
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const blue = '#255A8D';

const styles = {
  root: {
    "&:focused": {
      borderColor: blue
    },
  },
};

class StyledTextField extends React.PureComponent {
  render() {
    const { classes, children, className, ...other } = this.props;
    const errorClass = this.props.error ? 'InputWithErrors' : 'InputFocusLabel'
    return (
      <TextField classes={{
        root: classNames(classes.root, className, errorClass),
      }} {...other}
      InputProps={{
        classes: {
          error: 'TextInputContainer-error'
        }
      }}
      FormHelperTextProps={{
        classes: {
          root: 'TextInputHelperText',
          error: 'TextInput-error'
        }
      }}>
        {children || 'class names'}
      </TextField>
    );
  }

}

export default withStyles(styles)(StyledTextField);



// WEBPACK FOOTER //
// ./src/js/components/inputs/StyledTextField.js